import { render, staticRenderFns } from "./DiagnosticsList.vue?vue&type=template&id=95694a5c&scoped=true&"
import script from "./DiagnosticsList.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsList.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticsList.vue?vue&type=style&index=0&id=95694a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95694a5c",
  null
  
)

export default component.exports